import { Inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from 'rxjs';
import { DocumentPersonneAvertie } from "../entities/document-pa.entity";
import { DocumentPersonneAvertieResult } from "../entities/document-personne-avertie-result";
import { IntervenantPaInfo } from "../entities/intervenant-pa-info.entity";
import { UpdateStepEntrepriseOrder } from "../entities/document-pa-update-step-entreprise-order.entity";
import { UpdateStepDefinitionOrder } from "../entities/document-pa-update-step-definition-order.entity";
import { TraductionPaEntity } from "../entities/traduction-pa.entity";
import { GenericUpdateTraductionStepOrder } from "../entities/document-pa-generic-update-traduction-step-order.entity";
import { DocumentEchange } from "../entities/document-pa-echange";
import { DocEchangeUpdateStepOrder } from "../entities/document-pa-doc-echange-update-order";
import { UpdateStepValidationOrder } from "../entities/document-pa-update-step-validation-order.entity"
import { DocumentPaUrlUpdateOrder } from "../entities/document-pa-url-update-order.entity";
import { SignatairePaOrder } from "../entities/document-pa-signataire-order.entity";
import { PaSearchCriteria } from "../entities/personne-avertie-search-criteria";
import { DocumentPaAutreMesurePrevention } from "../entities/document-pa-autre-mesure-prevention.entity";
import { JSR310ConversionService } from '../../../shared/jsr310-localdates/services/jsr310-conversion.service';

@Injectable({ providedIn: 'root' })
export class DocumentPaService {

	private path: string;

	constructor(@Inject(HttpClient) private httpClient: HttpClient,
		@Inject(JSR310ConversionService) private jsr310Service: JSR310ConversionService ) {
		this.path = (window as any).baseApiPath;
	}

	// Méthode permettant de save definition PA
	public saveDefinitionStep(command: DocumentPersonneAvertie): Observable<DocumentPersonneAvertie> {
		if (!command.id) {
			command.version = 1;
		}
		const url = this.path + 'document-pa';
		const request = this.httpClient.post<DocumentPersonneAvertie>(url, command, {});
		return request;
	}
	
	// GET all Document PA
	public getStepDefinitionData(idPa: number): Observable<UpdateStepDefinitionOrder> {
		if (idPa) {
			const url = this.path + 'document-pa/step-data/definition/' + idPa;
			const request = this.httpClient.get<UpdateStepDefinitionOrder>(url);
			return request;
		} else {
			return of({} as UpdateStepDefinitionOrder);
		}
	}

	// GET all Document PA
	public getStepEntrepriseData(idPa: number): Observable<UpdateStepEntrepriseOrder> {
		if (idPa) {
			const url = this.path + 'document-pa/step-data/entreprises/' + idPa;
			const request = this.httpClient.get<UpdateStepEntrepriseOrder>(url);
			return request;
		} else {
			return of({} as UpdateStepEntrepriseOrder);
		}
	}

	// GET Consignes Generales Data
	public getStepConsignesGeneralesData(idPa: number): Observable<GenericUpdateTraductionStepOrder> {
		if (idPa) {
			const url = this.path + 'document-pa/step-data/consignesGenerales/' + idPa;
			const request = this.httpClient.get<GenericUpdateTraductionStepOrder>(url);
			return request;
		} else {
			return of({} as GenericUpdateTraductionStepOrder);
		}
	}
	
	// GET all Traductions
	public getTraductions(categorie: string, typeTraduction: string): Observable<TraductionPaEntity[]> {
		const url = this.path + 'document-pa/traductions/' + categorie + "/" + typeTraduction;
		const request = this.httpClient.get<TraductionPaEntity[]>(url);
		return request;
	}
	
	// GET Analyse Specifique Data
	public getAnalyseSpecifiqueData(idPa: number): Observable<GenericUpdateTraductionStepOrder> {
		if (idPa) {
			const url = this.path + 'document-pa/step-data/analyseSpecifiques/' + idPa;
			const request = this.httpClient.get<GenericUpdateTraductionStepOrder>(url);
			return request;
		} else {
			return of({} as GenericUpdateTraductionStepOrder);
		}
	}
	
	// GET Analyse Globale Data
	public getAnalyseGlobaleData(idPa: number): Observable<GenericUpdateTraductionStepOrder> {
		if (idPa) {
			const url = this.path + 'document-pa/step-data/analyseGlobale/' + idPa;
			const request = this.httpClient.get<GenericUpdateTraductionStepOrder>(url);
			return request;
		} else {
			return of({} as GenericUpdateTraductionStepOrder);
		}
	}
	
	// GET Document Echange  
	public getDocumentEchangeData(idPa: number): Observable<DocEchangeUpdateStepOrder> {
		if (idPa) {
			const url = this.path + 'document-pa/step-data/documents-echanges/' + idPa;
			const request = this.httpClient.get<DocEchangeUpdateStepOrder>(url);
			return request;
		} else {
			return of({} as DocEchangeUpdateStepOrder);
		}
	}

	// GET all Document PA
	public list(): Observable<DocumentPersonneAvertieResult[]> {
		const url = this.path + 'document-pa';
		const request = this.httpClient.get<DocumentPersonneAvertieResult[]>(url);
		return request;
	}
	
	public getDocumentsEchange(): Observable<DocumentEchange[]> {
		const url = this.path + 'document-pa/documents-echanges';
		const request = this.httpClient.get<DocumentEchange[]>(url);
		return request;
	}
	
	public getValidationData(idPa: number): Observable<UpdateStepValidationOrder> {
		if (idPa) {
			const url = this.path + 'document-pa/step-data/validation/' + idPa;
			const request = this.httpClient.get<UpdateStepValidationOrder>(url);
			return request;
		} else {
			return of({} as UpdateStepValidationOrder);
		}
	}
	
	// Méthode permettant de modifier un PA en step 1
	public updateDefinitionStep(command: UpdateStepDefinitionOrder): Observable<UpdateStepDefinitionOrder> {
		const url = this.path + 'document-pa/definition';
		const request = this.httpClient.put<UpdateStepDefinitionOrder>(url, command, {});
		return request;
	}

	// Méthode permettant de modifier un PA en step 2
	public updateEntrepriseStep(command: UpdateStepEntrepriseOrder): Observable<UpdateStepEntrepriseOrder> {
		const url = this.path + 'document-pa/entreprises';
		const request = this.httpClient.put<UpdateStepEntrepriseOrder>(url, command, {});
		return request;
	}

	// Méthode permettant de modifier un PA en step 3
	public updateConsigneSecuGeneraleStep(command: GenericUpdateTraductionStepOrder): Observable<GenericUpdateTraductionStepOrder> {
		const url = this.path + 'document-pa/consignesGenerales';
		const request = this.httpClient.put<GenericUpdateTraductionStepOrder>(url, command, {});
		return request;
	}
	
	// Méthode permettant de modifier un PA en step 4 (Consignes liées au risque électrique)
	public updateConsignePvStep(command: GenericUpdateTraductionStepOrder): Observable<GenericUpdateTraductionStepOrder> {
		const url = this.path + 'document-pa/consignesPv';
		const request = this.httpClient.put<GenericUpdateTraductionStepOrder>(url, command, {});
		return request;
	}

	// Méthode permettant de modifier un PA en step analyse specifique
	public updateAnalyseSpecifiqueStep(command: GenericUpdateTraductionStepOrder): Observable<GenericUpdateTraductionStepOrder> {
		const url = this.path + 'document-pa/analyseSpecifiques';
		const request = this.httpClient.put<GenericUpdateTraductionStepOrder>(url, command, {});
		return request;
	}

	// Méthode permettant de modifier un PA en step doc echange
	public updateDocEchangeStep(command: DocEchangeUpdateStepOrder): Observable<DocEchangeUpdateStepOrder> {
		const url = this.path + 'document-pa/documents-echanges';
		const request = this.httpClient.put<DocEchangeUpdateStepOrder>(url, command, {});
		return request;
	}
	
	// Méthode permettant de modifier un PA en step 6
	public updateSituationAnormaleStep(command: GenericUpdateTraductionStepOrder): Observable<GenericUpdateTraductionStepOrder> {
		const url = this.path + 'document-pa/consignesSituationAnormales';
		const request = this.httpClient.put<GenericUpdateTraductionStepOrder>(url, command, {});
		return request;
	}
	
	public updateAnalyseGlobalStep(command: GenericUpdateTraductionStepOrder): Observable<GenericUpdateTraductionStepOrder> {
		const url = this.path + 'document-pa/analyseGlobale';
		const request = this.httpClient.put<GenericUpdateTraductionStepOrder>(url, command, {});
		return request;
	}
	
	public updateValidationStep(command: UpdateStepValidationOrder): Observable<UpdateStepValidationOrder> {
		const url = this.path + 'document-pa/validation';
		const request = this.httpClient.put<UpdateStepValidationOrder>(url, command, {});
		return request;
	}
	
	// Méthode permettant de générer le PDF associé au PDP
	public generatePdf(formData: FormData): Observable<Blob> {
		let url = (window as any).uploadPath + '/pa';
		return this.httpClient.post(url, formData, {responseType: 'blob'});
	}
	
	// Méthode permettant d'archiver un PA
	public archive(idPa: number): Observable<any> {
		const url = this.path + 'document-pa/changeArchivalState/' + idPa;
		const request = this.httpClient.put(url, {});
		return request;
	}

	// Méthode permettant de supprimer un PA
	public supprimer(idPa: number): Observable<any> {
		const url = this.path + 'document-pa/delete/' + idPa;
		return this.httpClient.delete(url);
	}
	
	public addUrl(command: DocumentPaUrlUpdateOrder): Observable<DocumentPaUrlUpdateOrder> {
		const url = this.path + 'document-pa/addurl';
		return this.httpClient.put<DocumentPaUrlUpdateOrder>(url, command, {});
	}

	public signPa(command: SignatairePaOrder): Observable<SignatairePaOrder> {
		const url = this.path + 'document-pa/signatures';
		const request = this.httpClient.put<SignatairePaOrder>(url, command, {});
		return request;
	}
	
	// Methode permettant d'exporter les PA
	public export(exportCriteria: PaSearchCriteria): Observable<Blob> {
		const url = this.path + 'document-pa/export';
		return this.httpClient.post(url, exportCriteria, { responseType: 'blob' });
	};
	
	public intervenantPaInfo(intervenantId: number, parcId: number | null, dateLimit: Date): Observable<IntervenantPaInfo> {
		if (parcId) {
			let limit = this.jsr310Service.toLocalDateParam(dateLimit);
			const url = this.path + 'document-pa/intervenant/' + intervenantId + '/' + parcId + '?dateLimit=' + limit;
			return this.httpClient.get<IntervenantPaInfo>(url);			
		}
		let voidPaInfo = new IntervenantPaInfo();
		voidPaInfo.entreprisePa = false;
		voidPaInfo.paInfos = [];
		return of(voidPaInfo);
	}
	
	// GET Autres MP - Analyse Spécifique
	public getAutreMpsAnalyseSpecifique(idPa: number): Observable<DocumentPaAutreMesurePrevention[]> {
		if (!idPa) {
			return of([]);
		}
		const url = this.path + 'document-pa/step-data/analyseSpecifiques/autremps/' + idPa;
		return this.httpClient.get<DocumentPaAutreMesurePrevention[]>(url);
	}

	// GET Autres MP - Analyse Globale
	public getAutreMpsAnalyseGlobale(idPa: number): Observable<DocumentPaAutreMesurePrevention[]> {
		if (!idPa) {
			return of([]);
		}
		const url = this.path + 'document-pa/step-data/analyseGlobale/autremps/' + idPa;
		return this.httpClient.get<DocumentPaAutreMesurePrevention[]>(url);
	}
	
}